import { CitationIndex } from "../../../sources/models/Citation";
import { useEffect, useMemo } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { parseIntOrUndefined } from "../../../../shared/utils/Number";
import CenterLoader from "../../../../shared/components/loader/CenterLoader";
import SidebarCompanyDocumentLink from "./SidebarCompanyDocumentLink";
import { useGetTransciptSource } from "@/features/sources/api/useGetTransciptSource";
import { useGetFilingSource } from "@/features/sources/api/useGetFilingSource";
import { CitationSourceType } from "@/shared/enums/CitationSourceType";
import { CompanyDocumentView } from "@/shared/models/CompanyDocument";
import { CompanyDocumentType } from "@/shared/enums/CompanyDocumentType";

interface SidebarDocumentCitationProps {
  citation: CitationIndex;
  setWiderSidebar: (isWider: boolean) => void;
}

export function SidebarDocumentCitation({
  citation,
}: SidebarDocumentCitationProps) {
  const {
    source: transcriptSource,
    getTranscriptSource,
    isLoading: isTranscriptLoading,
    setSource: setTranscriptSource,
  } = useGetTransciptSource();

  const {
    source: filingSource,
    getFilingSource,
    isLoading: isLoadingFiling,
    setSource: setFilingSource,
  } = useGetFilingSource();

  const memoizedCitation = useMemo(() => citation, [citation]);

  useEffect(() => {
    setTranscriptSource(null);
    setFilingSource(null);
    if (memoizedCitation.sourceType === CitationSourceType.Transcript) {
      getTranscriptSource(
        parseInt(memoizedCitation.documentId),
        parseIntOrUndefined(memoizedCitation.chunkId),
      );
    } else if (memoizedCitation.sourceType === CitationSourceType.Filing) {
      getFilingSource(
        memoizedCitation.documentId,
        parseIntOrUndefined(memoizedCitation.chunkId),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memoizedCitation]);

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {(isLoadingFiling || isTranscriptLoading) && <CenterLoader />}
      <>
        <div className="flex">
          {(transcriptSource || filingSource) && (
            <SidebarCompanyDocumentLink
              document={
                new CompanyDocumentView({
                  id: memoizedCitation.documentId,
                  type: transcriptSource
                    ? CompanyDocumentType.Transcript
                    : CompanyDocumentType.Filing,
                  title: transcriptSource?.title || filingSource?.title || "",
                })
              }
              chunkId={parseIntOrUndefined(memoizedCitation.chunkId)}
            />
          )}
        </div>
        {(transcriptSource || filingSource) && (
          <ScrollArea className="mt-5">
            <p
              className="text-sm leading-relaxed"
              style={{ overflowWrap: "anywhere" }}
            >
              {(transcriptSource || filingSource)?.content}
            </p>
          </ScrollArea>
        )}
      </>
    </div>
  );
}
